export { HeaderCommon } from './HeaderCommon';
export type { HeaderCommonProps } from './HeaderCommon';
